(function () {
  function init(root) {
    if (!root || root.dataset.lfFilterReady === 'true') { return; }
    root.dataset.lfFilterReady = 'true';
    var section = root.closest('section') || document;
    var grid = section.querySelector('[data-lf-filter-grid]');
    if (!grid) { return; }
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-lf-tags]'));
    var inputs = Array.prototype.slice.call(root.querySelectorAll('[data-lf-filter-input]'));
    var clears = Array.prototype.slice.call(section.querySelectorAll('[data-lf-filter-clear]'));
    var empty = section.querySelector('[data-lf-filter-empty]');
    var totalEl = root.querySelector('[data-lf-filter-total]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-lf-filter-group]'));
    var sortForm = root.querySelector('[data-lf-sort-form]');
    var sortSel = root.querySelector('[data-lf-sort]');

    var data = cards.map(function (card) {
      var tags = (card.getAttribute('data-lf-tags') || '').split('|');
      var set = { age: [], gender: [] };
      tags.forEach(function (t) {
        if (t.indexOf('age:') === 0) { set.age.push(t.slice(4)); }
        else if (t.indexOf('gender:') === 0) { set.gender.push(t.slice(7)); }
      });
      return { el: card.closest('.product-card') || card, set: set };
    });

    function selected() {
      var s = { age: [], gender: [] };
      inputs.forEach(function (i) { if (i.checked) { s[i.dataset.lfFilterInput].push(i.value); } });
      return s;
    }

    function matches(item, s, skip) {
      return ['age', 'gender'].every(function (g) {
        if (g === skip || !s[g].length) { return true; }
        return s[g].some(function (v) { return item.set[g].indexOf(v) !== -1; });
      });
    }

    function apply(writeUrl) {
      var s = selected();
      var shown = 0;
      data.forEach(function (item) {
        var ok = matches(item, s);
        item.el.hidden = !ok;
        if (ok) { shown++; }
      });
      inputs.forEach(function (i) {
        var g = i.dataset.lfFilterInput;
        var n = 0;
        data.forEach(function (item) {
          if (item.set[g].indexOf(i.value) !== -1 && matches(item, s, g)) { n++; }
        });
        var c = i.closest('label').querySelector('[data-lf-filter-count]');
        if (c) { c.textContent = '(' + n + ')'; }
        i.closest('label').classList.toggle('is-empty', n === 0 && !i.checked);
      });
      groups.forEach(function (gEl) {
        var g = gEl.dataset.lfFilterGroup;
        var b = gEl.querySelector('[data-lf-filter-badge]');
        if (b) { b.hidden = !s[g].length; b.textContent = s[g].length; }
      });
      var active = s.age.length + s.gender.length > 0;
      clears.forEach(function (b) { if (b.closest('[data-lf-filter-empty]')) { return; } b.hidden = !active; });
      if (empty) { empty.hidden = shown !== 0 || !data.length; }
      if (totalEl) {
        if (active) {
          totalEl.textContent = (totalEl.dataset.template || '{{ count }} / {{ total }}').replace('{{ count }}', shown).replace('{{ total }}', data.length);
        } else if (totalEl.dataset.original) {
          totalEl.textContent = totalEl.dataset.original;
        }
      }
      if (writeUrl && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          ['age', 'gender'].forEach(function (g) {
            if (s[g].length) { url.searchParams.set(g, s[g].join(',')); } else { url.searchParams.delete(g); }
          });
          url.searchParams.delete('page');
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    if (totalEl) { totalEl.dataset.original = totalEl.textContent; }

    try {
      var params = new URL(window.location.href).searchParams;
      inputs.forEach(function (i) {
        var vals = (params.get(i.dataset.lfFilterInput) || '').split(',');
        if (vals.indexOf(i.value) !== -1) { i.checked = true; }
      });
    } catch (e) {}

    inputs.forEach(function (i) { i.addEventListener('change', function () { apply(true); }); });
    clears.forEach(function (b) {
      b.addEventListener('click', function () {
        inputs.forEach(function (i) { i.checked = false; });
        apply(true);
      });
    });

    document.addEventListener('click', function (e) {
      groups.forEach(function (g) { if (g.open && !g.contains(e.target)) { g.open = false; } });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') { return; }
      groups.forEach(function (g) { if (g.open) { g.open = false; var s = g.querySelector('summary'); if (s) { s.focus(); } } });
    });
    groups.forEach(function (g) {
      g.addEventListener('toggle', function () {
        if (!g.open) { return; }
        groups.forEach(function (o) { if (o !== g) { o.open = false; } });
      });
    });

    if (sortSel && sortForm) {
      sortSel.addEventListener('change', function () {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sortSel.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        } catch (e) { sortForm.submit(); }
      });
    }

    apply(false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-lf-filter]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
